export default function(fields) {
  return {
    ...fields,
    urlAssessorReportPhotos: fields.files && fields.files.map(item => item.url),
    files: undefined,
    helpers: undefined
  }
}
